import { useQuery } from '@apollo/client';

import { useUserInfoContext } from '~/context/UserInfoProvider';
import { GET_VIDEO_QUESTION } from '~/graphql/videos';
import { Query, QueryGetVideoQuestionV2Args } from '~/types';

const useQuestion = (videoId) => {
  const { userInfo } = useUserInfoContext();

  const { data: questionData, refetch: refetchQuestionData } = useQuery<
    Pick<Query, 'GetVideoQuestionV2'>,
    QueryGetVideoQuestionV2Args
  >(GET_VIDEO_QUESTION, {
    variables: {
      video_id: +videoId,
      include_test_publish_status: true,
    },
    skip: !videoId || !userInfo,
    fetchPolicy: 'no-cache',
  });

  const question = questionData?.GetVideoQuestionV2;

  return {
    question,
    refetchQuestion: refetchQuestionData,
  };
};

export default useQuestion;
